"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedlock = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 46 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedlock` : '') + (description ? ` desc-brandedlock` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedlock"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedlock"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.9789 15.9981V22H30.9815V15.9981C30.9815 11.5917 27.4001 7.99904 22.9947 7.99904C18.5893 7.99904 14.9974 11.6023 14.9974 15.9981V22H7V15.9981C7 7.17483 14.1839 0 23.0053 0C31.8267 0 39 7.17483 39 15.9981H38.9789Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42.1633 22.0106H23V56H42.1633C44.279 56 46 54.215 46 51.9969V26.0031C46 23.7956 44.2892 22 42.1633 22V22.0106Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23 22H3.83671C1.72095 22 0 23.785 0 26.0031V51.9969C0 54.2044 1.71083 56 3.83671 56H23V22Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28 31.6305C28 29.0698 25.765 27 23 27C20.235 27 18 29.0698 18 31.6305C18 33.4122 19.0945 34.9379 20.6843 35.7168L18 49H28L25.3157 35.7168C26.9055 34.9379 28 33.4122 28 31.6305Z",
    fill: "#FFF5EB"
  }));
};
var _default = exports.default = brandedlock;